/**
 * KLG Quotes API
 *
 * Contact: xxx@kaplan.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { QuoteInputApiDto } from './quote-input.model';

export interface DeeplinkRequestApiDto {
  company?: DeeplinkRequestApiDto.CompanyEnum;
  quoteInput?: QuoteInputApiDto;
  preselectedMode?: DeeplinkRequestApiDto.PreselectedModeEnum;
  deeplinkType?: DeeplinkRequestApiDto.DeeplinkTypeEnum;
  destination?: string;
  studyLanguage?: string;
  classStartTime?: string;
  classEndTime?: string;
}
export namespace DeeplinkRequestApiDto {
  export const CompanyEnum = {
    KIL: 'KIL',
    PL: 'PL',
    ALP: 'ALP',
    ESL: 'ESL',
  } as const;
  export type CompanyEnum = (typeof CompanyEnum)[keyof typeof CompanyEnum];
  export const PreselectedModeEnum = {
    STUDY_AND_STAY: 'STUDY_AND_STAY',
    JUNIOR_CAMP: 'JUNIOR_CAMP',
    ONLINE_COURSE: 'ONLINE_COURSE',
    ACADEMIC_YEAR_ABROAD: 'ACADEMIC_YEAR_ABROAD',
    SELECTED_SCHOOL: 'SELECTED_SCHOOL',
  } as const;
  export type PreselectedModeEnum = (typeof PreselectedModeEnum)[keyof typeof PreselectedModeEnum];
  export const DeeplinkTypeEnum = {
    COPY_SELECTION: 'COPY_SELECTION',
    PRICING_PACKAGE: 'PRICING_PACKAGE',
    GENERIC: 'GENERIC',
  } as const;
  export type DeeplinkTypeEnum = (typeof DeeplinkTypeEnum)[keyof typeof DeeplinkTypeEnum];
}
